import React from 'react';
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from '../libs/utils/Const'

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((document, index) => {

        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[0].value && <td>{document.SeriesCode}</td>}
                {headers[1].value && <td>{document.DocStatus === 'C' ? 'Cerrado' : 'Abierto'}</td>}
                {headers[2].value && <td>{document.DocNum ?? ''}</td>}

                {headers[3].value && <td>{document?.CardCode ?? ''}</td>}
                {headers[4].value && <td>{document?.CardName ?? ''}</td>}
                {headers[5].value && <td>{moment(document?.DocDate).format('YYYY-MM-DD') ?? ''}</td>}

                {headers[6].value && <td>{document?.Comments ?? ''}</td>}
                {headers[7].value && <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(document?.DocTotal) ?? ''}</td>}
                {headers[8].value && <td>{moment(document?.DocDueDate).format('YYYY-MM-DD') ?? ''}</td>}

                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails(document)}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            {headers[8].value && <td>{headers[8].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderPendingTimbraDocs = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);

}